export const BOOKINGS_VIEW_LIST = 'list';
export const BOOKINGS_VIEW_CALENDAR = 'calendar';
export const BOOKINGS_VIEW_STORAGE_KEY = 'slBookingsView';

/**
 * Normalize a List | Calendar choice.
 *
 * @param {string} [value]
 * @returns {string}
 */
export const normalizeBookingsView = value =>
  value === BOOKINGS_VIEW_CALENDAR ? BOOKINGS_VIEW_CALENDAR : BOOKINGS_VIEW_LIST;

/**
 * Last chosen My Bookings view.
 *
 * @returns {string}
 */
export const readBookingsView = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return BOOKINGS_VIEW_LIST;
  }
  try {
    return normalizeBookingsView(window.localStorage.getItem(BOOKINGS_VIEW_STORAGE_KEY));
  } catch (e) {
    return BOOKINGS_VIEW_LIST;
  }
};

/**
 * Remember List vs Calendar.
 *
 * @param {string} value
 */
export const writeBookingsView = value => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  try {
    window.localStorage.setItem(BOOKINGS_VIEW_STORAGE_KEY, normalizeBookingsView(value));
  } catch (e) {
    // Safari private mode
  }
};

/**
 * `?view=` from the current My Bookings URL.
 *
 * @param {string} [search]
 * @returns {string|null}
 */
export const bookingsViewFromSearch = search => {
  if (!search || typeof search !== 'string') {
    return null;
  }
  const raw = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search).get('view');
  if (raw === BOOKINGS_VIEW_LIST || raw === BOOKINGS_VIEW_CALENDAR) {
    return raw;
  }
  return null;
};
